// API helper for bookings
import config from '../config';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? config.production.apiUrl 
  : config.development.apiUrl;

export const bookingsAPI = {
  // Get all bookings
  async getBookings() {
    try {
      const response = await fetch(`${API_BASE_URL}bookings.php`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching bookings:', error);
      throw error;
    }
  },

  // Add new bookings
  async addBookings(bookings) {
    try {
      const response = await fetch(`${API_BASE_URL}bookings.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bookings }),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error adding bookings:', error);
      throw error;
    }
  },

  // Delete booking by date
  async deleteBooking(date) {
    try {
      const response = await fetch(`${API_BASE_URL}bookings.php`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ date }),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error deleting booking:', error);
      throw error;
    }
  }
};
